import { render } from "./CheckboxGroupAnswer.vue?vue&type=template&id=360dd4fa"
import script from "./CheckboxGroupAnswer.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__